// Propuesta de alquiler y acta de entrega de equipos (31-oct-2026): arman la hoja con el diseño limpio y la descargan.
// Lo que se dibuja está en v2/alquiler.js; acá van la cabecera, el número, el pie y la descarga.
import jsPDF from 'jspdf';
import { generarNroDocumento } from './theme.js';
import { dibujarFooter } from './layout.js';
import { cabecera } from './v2/base.js';
import { generarAlquilerV2 } from './v2/alquiler.js';
import { generarActaEntregaV2 } from './v2/actaEntrega.js';
import { generarContratoV2 } from './v2/contrato.js';
import { guardarPDF } from './entregar.js';

const hoy = () => new Date().toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });

export function generarPropuestaAlquiler({ cliente = null, sede = null, a, autor = '' }) {
    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const fecha = hoy();
    const nro = generarNroDocumento('ALQ', fecha, autor || 'Dispenser La Tienda');
    const ctx = { titulo: a.resumido ? 'Cotización de alquiler' : 'Propuesta de alquiler', sub: `N° ${nro} · ${fecha} · Válida por ${a.validezDias || 15} días` };
    const y = cabecera(doc, ctx);
    generarAlquilerV2(doc, { ctx, cliente, sede, y, a });
    const n = doc.getNumberOfPages();
    for (let i = 1; i <= n; i += 1) { doc.setPage(i); dibujarFooter(doc, { pagina: i, totalPaginas: n }); }
    const nombre = String(cliente?.nombre || '').trim().replace(/[^\w\sáéíóúñÁÉÍÓÚÑ-]/g, '').replace(/\s+/g, '_');
    guardarPDF(doc, `${a.resumido ? 'Cotizacion' : 'Propuesta'}_Alquiler${nombre ? `_${nombre}` : ''}_${nro}.pdf`);
}

// Acta de entrega de los equipos alquilados, con la firma de quien recibe
export function generarActaEntrega({ cliente, sede, e, autor = '' }) {
    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const ahora = new Date();
    const fecha = ahora.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const hora = ahora.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit', hour12: false });
    const nro = generarNroDocumento('ENT', fecha, autor || 'Dispenser La Tienda');
    const ctx = { titulo: 'Acta de entrega', sub: `N° ${nro} · ${fecha} · Equipos en alquiler` };
    const y = cabecera(doc, ctx);
    generarActaEntregaV2(doc, { ctx, cliente, sede, y, e: { ...e, fecha, hora } });
    const n = doc.getNumberOfPages();
    for (let i = 1; i <= n; i += 1) { doc.setPage(i); dibujarFooter(doc, { pagina: i, totalPaginas: n }); }
    const nombre = String(cliente?.nombre || '').trim().replace(/[^\w\sáéíóúñÁÉÍÓÚÑ-]/g, '').replace(/\s+/g, '_');
    guardarPDF(doc, `Acta_Entrega${nombre ? `_${nombre}` : ''}_${nro}.pdf`);
}

// Contrato de alquiler con los datos de la empresa y del alquiler ya cargados
export function generarContratoAlquiler({ c, autor = '' }) {
    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const fecha = hoy();
    const nro = generarNroDocumento('CTR', fecha, autor || 'Dispenser La Tienda');
    const ctx = { titulo: 'Contrato de alquiler', sub: `N° ${nro} · ${c.locatario?.nombre || ''}` };
    const y = cabecera(doc, ctx);
    const [d, m, a] = fecha.split('/');
    const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    generarContratoV2(doc, { ctx, y, c: { ...c, fecha: `${Number(d)} días del mes de ${MESES[Number(m) - 1]} de ${a}` } });
    const n = doc.getNumberOfPages();
    for (let i = 1; i <= n; i += 1) { doc.setPage(i); dibujarFooter(doc, { pagina: i, totalPaginas: n, textoCentral: 'Contrato de alquiler de equipos · Dispenser La Tienda' }); }
    const nombre = String(c.locatario?.nombre || '').trim().replace(/[^\w\sáéíóúñÁÉÍÓÚÑ-]/g, '').replace(/\s+/g, '_');
    guardarPDF(doc, `Contrato_Alquiler${nombre ? `_${nombre}` : ''}_${nro}.pdf`);
}
